// Currency configuration and formatting utilities
export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar', locale: 'en-US' },
  { code: 'EUR', symbol: '€', name: 'Euro', locale: 'de-DE' },
  { code: 'GBP', symbol: '£', name: 'British Pound', locale: 'en-GB' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', locale: 'en-IN' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', locale: 'ja-JP' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', locale: 'zh-CN' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', locale: 'en-AU' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', locale: 'en-CA' },
];

/**
 * Get currency config by code
 */
export const getCurrencyConfig = (code) => {
  return CURRENCIES.find(c => c.code === code) || CURRENCIES[0];
};

/**
 * Get currency symbol by code
 */
export const getCurrencySymbol = (code) => {
  const config = getCurrencyConfig(code);
  return config.symbol;
};

/**
 * Format amount with the selected currency
 * @param {number} amount - The amount to format
 * @param {string} currencyCode - The currency code (USD, EUR, etc.)
 * @param {object} options - Additional formatting options
 */
export const formatCurrency = (amount, currencyCode = 'USD', options = {}) => {
  const config = getCurrencyConfig(currencyCode);
  const { compact = false, showDecimals = false } = options;
  
  const absAmount = Math.abs(amount);
  
  if (compact && absAmount >= 1000) {
    return config.symbol + (amount / 1000).toFixed(1) + 'k';
  }
  
  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(amount);
};

/**
 * Format amount with just the symbol (simpler format)
 * @param {number} amount - The amount to format
 * @param {string} currencyCode - The currency code (USD, EUR, etc.)
 */
export const formatAmount = (amount, currencyCode = 'USD') => {
  const config = getCurrencyConfig(currencyCode);
  const absAmount = Math.abs(amount);
  return config.symbol + absAmount.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
};

/**
 * Format amount in compact form (e.g., $1.2k)
 */
export const formatCompact = (amount, currencyCode = 'USD') => {
  const config = getCurrencyConfig(currencyCode);
  const absAmount = Math.abs(amount);
  
  if (absAmount >= 1000) {
    return config.symbol + (amount / 1000).toFixed(1) + 'k';
  }
  return config.symbol + amount.toFixed(0);
};
